import styled from "@emotion/styled"
import { ReloadOutlined, SendOutlined } from "@ant-design/icons"
import { Button, Card, Col, Row, Tabs, Typography } from "antd"
import { goBack } from "assets/icons"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useQueryClient } from "@tanstack/react-query"
import { useAppSelector } from "store"
import DepartmentDetailTab from "./DepartmentDetailTab"
import DistributeStockModal from "./DistributeStockModal"
import OverviewTab from "./OverviewTab"
import WarehouseListTab from "./WarehouseListTab"

const DepartmentStock = () => {
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const profile = useAppSelector((state) => state.auth.profile)
  const factoryId = profile?.user?.role?.ref_id ?? ""

  const [activeKey, setActiveKey] = useState("2")
  const [openDistribute, setOpenDistribute] = useState(false)

  const handleRefresh = () => {
    queryClient.invalidateQueries({ queryKey: ["factory_store"] })
    queryClient.invalidateQueries({ queryKey: ["department_warehouses"] })
    queryClient.invalidateQueries({ queryKey: ["department_stock_overview"] })
    queryClient.invalidateQueries({ queryKey: ["department_store"] })
    queryClient.invalidateQueries({ queryKey: ["department_stock_movements"] })
  }

  const items = [
    // {
    //   label: "ภาพรวม",
    //   key: "1",
    //   children: <OverviewTab factoryId={factoryId} />,
    // },
    {
      label: "คลังทั้งหมด",
      key: "2",
      children: <WarehouseListTab />,
    },
    {
      label: "รายละเอียดตามแผนก",
      key: "3",
      children: <DepartmentDetailTab />,
    },
  ]

  return (
    <>
      <Row className="rowgap-vbox" gutter={[24, 0]}>
        <Col span={24}>
          <Card bordered={false} className="criclebox h-full tabs-mobile">
            <HeaderTabs>
              <IconWrapper onClick={() => navigate("/dashboard")}>
                <SpanIcon>{goBack}</SpanIcon>
              </IconWrapper>
              <Typography.Title level={5} style={{ margin: 0 }}>
                คลัแผนก
              </Typography.Title>
              <RightWrap>
                <Button
                  icon={<ReloadOutlined />}
                  onClick={handleRefresh}
                  size="middle"
                >
                  รีเฟรช
                </Button>
                <Button
                  type="primary"
                  icon={<SendOutlined />}
                  onClick={() => setOpenDistribute(true)}
                  size="middle"
                >
                  การโอนสินค้า
                </Button>
              </RightWrap>
            </HeaderTabs>
            <Tabs
              activeKey={activeKey}
              onChange={setActiveKey}
              items={items}
              style={{ padding: "0 8px" }}
            />
          </Card>
        </Col>
      </Row>

      <DistributeStockModal
        open={openDistribute}
        onClose={() => setOpenDistribute(false)}
      />
    </>
  )
}

export default DepartmentStock

const HeaderTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-direction: row;
  border-bottom: 1px solid #efefef;
  gap: 8px;
  flex-wrap: wrap;
`

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`

const RightWrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`
